import { useState, useCallback } from 'react';
import { j203Api, FJ130 } from '../../../services/j203Api';

interface LookupNames {
  customer: string;
  employee: string;
  department: string;
  currency: string;
  [key: string]: string;
}

export function useJ203LookupNames() {
  const [names, setNames] = useState<LookupNames>({
    customer: '', employee: '', department: '', currency: '',
  });

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    if (!code || !code.trim()) {
      setNames(prev => ({ ...prev, [nameKey]: '' }));
      return;
    }
    const name = await j203Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const resolveAllNames = useCallback(async (data: Partial<FJ130>) => {
    const promises = [
      j203Api.lookupName('customer', data.fj130_12 || ''),
      j203Api.lookupName('employee', data.fj130_21 || ''),
      j203Api.lookupName('department', data.fj130_22 || ''),
      j203Api.lookupName('currency', data.fj130_14 || ''),
    ];
    const [customer, employee, department, currency] = await Promise.all(promises);
    setNames({ customer, employee, department, currency });
  }, []);

  const clearNames = useCallback(() => {
    setNames({ customer: '', employee: '', department: '', currency: '' });
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
